// extracted by mini-css-extract-plugin
export default {"pop_wrapper":"styles_pop_wrapper__-G+BC"};